import * as React from "react"
import * as SliderPrimitive from "@radix-ui/react-slider"

import { cn } from "@/lib/utils"

const Slider = React.forwardRef(({ className, ...props }, ref) => (
  <SliderPrimitive.Root
    ref={ref}
    className={cn("relative flex w-full touch-none select-none items-center py-2 cursor-pointer", className)}
    {...props}>
    <SliderPrimitive.Track
      className="relative h-2.5 w-full grow overflow-hidden rounded-full bg-[#8A9AA3]/45">
      <SliderPrimitive.Range className="absolute h-full bg-[#D4A62A]" />
    </SliderPrimitive.Track>
    <SliderPrimitive.Thumb
      aria-label="Træk for at justere"
      className="block h-7 w-7 rounded-full border-[3px] border-[#D4A62A] bg-white shadow-[0_2px_8px_rgba(31,46,51,0.35)] ring-4 ring-[#D4A62A]/20 transition-transform hover:scale-110 focus-visible:outline-none focus-visible:ring-[#D4A62A]/50 disabled:pointer-events-none disabled:opacity-50" />
  </SliderPrimitive.Root>
))
Slider.displayName = SliderPrimitive.Root.displayName

export { Slider }